import { createContext, useContext } from "react";

interface ProductFacetContextType {
  filterCount: number;
}

const ProductFacetContext = createContext<ProductFacetContextType | null>(null);

const useProductFacetContext = () => {
  const context = useContext(ProductFacetContext);

  if (!context) {
    throw new Error("useProductFacetContext must be used within a ProductFacetContextProvider");
  }

  return context;
};

export {
  ProductFacetContext,
  useProductFacetContext,
};
